module.exports = __webpack_public_path__ + "img/服务伙伴03.dea97bf9.png";